import { useRoute } from 'navigation/hooks';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { NOT_IN_MY_CODE_SCREEN_POLLING_INTERVAL_MS } from 'state/loyalty/in-restaurant-redemption/utils';
import { routes } from 'utils/routing';

export function usePollingInterval() {
  const { pathname } = useRoute();
  let intervalMs = useFlag(LaunchDarklyFlag.LOYALTY_IN_RESTAURANT_STATUS_POLL_INTERVAL_MS);

  intervalMs = pathname !== routes.myCode ? NOT_IN_MY_CODE_SCREEN_POLLING_INTERVAL_MS : intervalMs;

  return intervalMs;
}
